module.exports = __webpack_public_path__ + "static/media/david.fb7aeb10.png";